export default function ExpertiseSection() {
  const expertise = [
    {
      number: '01',
      title: '무의식에 각인',
      description: '모든 위대한 게임 마케팅은 이야기에서 시작됩니다. 게임의 핵심 스토리를 찾아내고, 그것을 세상에 퍼뜨립니다.'
    },
    {
      number: '02',
      title: '기획 제공',
      description: '레퍼런스 리서치부터 시작하여 게임 브랜드에 가장 적합한 마케팅 기획을 진행합니다. 데이터와 트렌드를 기반으로 최선의 전략을 수립합니다.'
    },
    {
      number: '03',
      title: '재료 준비',
      description: '개발사가 준비할 재료를 최소화합니다. 가능한 선에서 재료를 직접 준비하고, 공수가 적게끔 기획적으로 개선합니다. 개발사는 요청하는 재료만 준비해주시면 됩니다.'
    },
    {
      number: '04',
      title: '다채널 전략',
      description: '퍼포먼스 마케팅, 브랜딩 영상, 유튜브 쇼츠를 통한 바이럴 마케팅 등 다양한 경로를 활용합니다. 최선의 성과를 위해 모든 채널을 전략적으로 운영합니다.'
    }
  ];

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Dark background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0f0f0f] to-[#1a1a1a]"></div>
      
      {/* Moody side lighting */}
      <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-[#F6B766]/8 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-[#F4A259]/6 rounded-full blur-[120px]"></div>

      <div className="relative z-10 container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#F6B766]/50"></div>
            <span className="mx-4 text-[#F6B766]/70 text-sm tracking-[0.3em] uppercase">RumorFlow</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#F6B766]/50"></div>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-light text-white mb-6">
            소문처럼 <span className="text-[#F6B766]">퍼져나가는</span>
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto font-light leading-relaxed">
            개발사의 스트레스를 줄이고, 게임이 자연스럽게 전세계에 퍼져나가도록 돕습니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {expertise.map((item, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-white/[0.03] to-transparent border border-white/5 rounded-2xl p-10 hover:border-[#F6B766]/20 transition-all duration-500"
            >
              {/* Number badge */}
              <div className="absolute -top-4 -left-4 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#F6B766] to-[#F4A259] rounded-xl shadow-lg shadow-[#F6B766]/20">
                <span className="text-black font-bold text-lg">{item.number}</span>
              </div>

              <div className="mt-6">
                <h3 className="text-2xl font-light text-white mb-4 group-hover:text-[#F6B766] transition-colors">
                  {item.title}
                </h3>
                
                <p className="text-white/60 leading-relaxed font-light">
                  {item.description}
                </p>
              </div>

              {/* Subtle glow on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#F6B766]/0 to-transparent group-hover:from-[#F6B766]/5 rounded-2xl transition-all duration-500 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Bottom quote */}
        <div className="mt-20 text-center">
          <div className="max-w-4xl mx-auto p-10 bg-gradient-to-r from-transparent via-white/5 to-transparent border-y border-white/10">
            <p className="text-2xl text-white/70 italic font-light leading-relaxed mb-4">
              "조용히 퍼져나가는 입소문처럼, 당신의 게임이 세계를 움직입니다"
            </p>
            <p className="text-[#F6B766] font-medium">— Haddon Kim, Creative Director</p>
          </div>
        </div>
      </div>
    </section>
  );
}
